import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { selectSchool, selectSchoolAcceptInvite } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './SchoolSelector.css';

function SchoolSelector({ schools, invites, email, password, onSchoolSelect }) {
  const [error, setError] = useState('');

  const handleSchoolClick = async (schoolId) => {
    try {
      const result = await selectSchool(email, password, schoolId);
      onSchoolSelect(result.data.token, result.data.timezone);
    } catch (error) {
      setError(mapErrorMessage(error.message));
    }
  };

  const handleInviteClick = async (inviteId) => {
    try {
      const result = await selectSchoolAcceptInvite(email, password, inviteId);
      onSchoolSelect(result.data.token, result.data.timezone);
    } catch (error) {
      setError(mapErrorMessage(error.message));
    }
  };

  return (
    <div>
    <div className="lp-topbar">
      <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
    </div>
    <div className="school-selector-container">
      <div className="school-selector">
        {error && <p className="error-message">{error}</p>}
        {schools && schools.length > 0 && (
          <div className="school-invites">
            <h2>Select a School</h2>
            <div className="school-list">
              {schools.map((school) => (
                <div
                  key={school.id}
                  className={`school-card ${!school.active ? 'school-card-inactive' : ''}`}
                  onClick={school.active ? () => handleSchoolClick(school.id) : null}
                >
                  <h3>{school.name}</h3>
                  <p>{school.sevp_code}</p>
                  {school.active ? (
                    <p>Payment Due: {new Date(school.payment_date).toLocaleDateString()}</p>
                  ) : (
                    <p className='status-inactive'>Payment Required</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {invites && invites.length > 0 && (
          <div className="school-invites invites-block">
            <h2>Invites</h2>
            <div className="school-list">
              {invites.map((invite) => (
                <div
                  key={invite.invite_id}
                  className={`school-card`}
                  onClick={() => handleInviteClick(invite.invite_id)}
                >
                  <h3>{invite.name}</h3>
                  <p>{invite.sevp_code}</p>
                  {invite.inviter && <p>Inviter: {invite.inviter.first_name} {invite.inviter.last_name}</p>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default SchoolSelector;